/**
 * Dropdowns Module
 * Custom vanilla JS dropdown functionality
 */

import { closest } from '../utils/dom.js';

// Track teleported dropdowns so we can restore them on close
const teleported = new Map();

export function init() {
	const dropdownToggles = document.querySelectorAll('[data-dropdown-toggle]');

	if (!dropdownToggles.length) return;

	dropdownToggles.forEach(toggle => {
		toggle.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();

			const dropdownMenu = this.nextElementSibling;
			if (!dropdownMenu || !dropdownMenu.classList.contains('dropdown-menu')) return;

			const isOpen = dropdownMenu.classList.contains('show');

			// Close all other dropdowns
			closeAllDropdowns();

			// Toggle current dropdown
			if (!isOpen) {
				const rect = this.getBoundingClientRect();

				// Store original context references before teleporting
				const originTabContent = dropdownMenu.closest('.tab-content[id^="certifications-table-tab-tableContent"]');
				if (originTabContent) {
					dropdownMenu._originTabContent = originTabContent;
				}
				dropdownMenu._originToggle = this;

				// Create a placeholder to remember where the menu was
				const placeholder = document.createComment('dropdown-placeholder');
				dropdownMenu.parentNode.insertBefore(placeholder, dropdownMenu);

				// Move dropdown to body
				document.body.appendChild(dropdownMenu);

				// Position it exactly where it would have been
				dropdownMenu.style.position = 'fixed';
				dropdownMenu.style.top = rect.bottom + 'px';
				dropdownMenu.style.left = rect.left + 'px';
				dropdownMenu.style.minWidth = rect.width + 'px';
				dropdownMenu.style.zIndex = '9999';

				teleported.set(dropdownMenu, { placeholder, toggle: this });

				dropdownMenu.classList.add('show');
				this.setAttribute('aria-expanded', 'true');
			}
		});
	});

	// Close dropdowns when clicking outside
	document.addEventListener('click', function(e) {
		if (!closest(e.target, '.dropdown') && !closest(e.target, '.dropdown-menu')) {
			closeAllDropdowns();
		}
	});

	// Close dropdowns on ESC key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape') {
			closeAllDropdowns();
		}
	});

	// Close dropdowns on scroll
	window.addEventListener('scroll', function() {
		if (teleported.size > 0) {
			closeAllDropdowns();
		}
	}, true);
}

export function closeAllDropdowns() {
	const openDropdowns = document.querySelectorAll('.dropdown-menu.show');
	openDropdowns.forEach(menu => {
		menu.classList.remove('show');

		// Restore teleported dropdown to its original position
		const info = teleported.get(menu);
		if (info) {
			menu.style.position = '';
			menu.style.top = '';
			menu.style.left = '';
			menu.style.minWidth = '';
			menu.style.zIndex = '';
			info.placeholder.parentNode.insertBefore(menu, info.placeholder);
			info.placeholder.remove();
			teleported.delete(menu);
			info.toggle.setAttribute('aria-expanded', 'false');
		} else {
			const toggle = menu.previousElementSibling;
			if (toggle) {
				toggle.setAttribute('aria-expanded', 'false');
			}
		}
	});
}
